import { Box, Button, Container, Typography } from '@mui/material';
import React from 'react';
import Logo from './components/Logo';
import { color } from '../shared/ui';

const colors = { primary: color.brand };

export default function ResetPasswordSuccess({ navTo }) {
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Logo />
      <Container sx={{ maxWidth: 428, textAlign: 'center' }}>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            mb: 4,
            color: colors.primary,
          }}
        >
          Password Reset
        </Typography>
        <Typography sx={{ mb: 4 }}>Your password has been reset.</Typography>
        <Button
          variant="contained"
          onClick={() => navTo('login')}
          sx={{ backgroundColor: colors.primary }}
        >
          Return to Login
        </Button>
      </Container>
    </Box>
  );
}
